
import React, {
  PropTypes
} from 'react';

import FA from 'react-fontawesome';

const Header = ({ service }) => (
  <div>
    <span className="fa-stack stack_container">
      <FA
        name="circle"
        stack="2x"
      />

      <FA
        name={service.icon}
        // spin

        stack="1x"
        className="stack_in"
      />
    </span>

    <h3>{service.title}</h3>
  </div>
);

Header.propTypes = {
  service: PropTypes.shape().isRequired
};

export default Header;



// WEBPACK FOOTER //
// ./src/components/services/Header.js